var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicenseBasic = function SvgLicenseBasic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DF5C2",
    d: "m.235 8.586 1.683-2.92 6.317 1.775v3.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05E59B",
    d: "m16.235 8.586-1.683-2.92-6.318 1.775v3.414z"
  })));
};
export default SvgLicenseBasic;